import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaYoutube,
  FaGlobe,
  FaLinkedin,
  FaGithub,
} from "react-icons/fa";

const ContactInfo = () => {
  const ContactInfos = [
    {
      CName: "Facebook",
      id: 1,
      CIcon: <FaFacebookF />,
      CLink: "https://web.facebook.com/profile.php?id=100075154102476",
    },
    {
      CName: "Github",
      id: 2,
      CIcon: <FaGithub />,
      CLink: "https://github.com/sahriarovi174506",
    },

    {
      CName: "Linked In",
      id: 3,
      CIcon: <FaLinkedin />,
      CLink: "https://www.linkedin.com/in/sahriar-alam-4b4640229/",
    },
  ];
  return (
    <div className="contact_info">
      {ContactInfos.map((CInfos) => (
        <div className="contact_item" key={CInfos.id}>
          <h4 className="Cname">{CInfos.CName}</h4>
          <div className="cIcon_cLink">
            <span>{CInfos.CIcon}</span>
            <a href={CInfos.CLink} className="Cname">
              {CInfos.CLink}
            </a>
          </div>
        </div>
      ))}
      <div className="contact_item">
        <h4 className="Cname">Social Profiles</h4>
        <div className="cIcon_cLink social_links">
          <span>
            <a href="https://web.facebook.com/profile.php?id=100075154102476">
              {<FaFacebookF />}
            </a>
          </span>
          <span>
            <a href="https://www.linkedin.com/in/sahriar-alam-4b4640229/">
              {<FaLinkedin />}
            </a>
          </span>
          <span>
            <Link to="/contact">{<FaYoutube />}</Link>
          </span>
          <span>
            <Link to="/contact">{<FaGlobe />}</Link>
          </span>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
